export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check Address"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter address"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select blockchain"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Run Check"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Low Risk"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Medium Risk"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["High Risk"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not on blacklist"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check Another Address"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download PDF"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select provider"])}
}